import type { FieldType, ISiteCapacity } from '@/interfaces'

export class SiteCapacity implements ISiteCapacity {
	[key: string]: FieldType
	id: number
	portlandHours: number
	portlandHeadcount: number
	morganHillHours: number
	morganHillHeadcount: number
	losAngelesHours: number
	losAngelesHeadcount: number
	chicagoHours: number
	chicagoHeadcount: number
	northCarolinaHours: number
	northCarolinaHeadcount: number
	hartfordHours: number
	hartfordHeadcount: number
	trumbullHours: number
	trumbullHeadcount: number
	weekOf: Date | string
	constructor({
		id,
		portlandHours,
		portlandHeadcount,
		morganHillHours,
		morganHillHeadcount,
		losAngelesHours,
		losAngelesHeadcount,
		chicagoHours,
		chicagoHeadcount,
		northCarolinaHours,
		northCarolinaHeadcount,
		hartfordHours,
		hartfordHeadcount,
		trumbullHours,
		trumbullHeadcount,
		weekOf
	}: ISiteCapacity) {
		this.id = id
		this.portlandHours = portlandHours
		this.portlandHeadcount = portlandHeadcount
		this.morganHillHours = morganHillHours
		this.morganHillHeadcount = morganHillHeadcount
		this.losAngelesHours = losAngelesHours
		this.losAngelesHeadcount = losAngelesHeadcount
		this.chicagoHours = chicagoHours
		this.chicagoHeadcount = chicagoHeadcount
		this.northCarolinaHours = northCarolinaHours
		this.northCarolinaHeadcount = northCarolinaHeadcount
		this.hartfordHours = hartfordHours
		this.hartfordHeadcount = hartfordHeadcount
		this.trumbullHours = trumbullHours
		this.trumbullHeadcount = trumbullHeadcount
		this.weekOf = weekOf
	}

	get pdx() {
		return this.portlandHours
	}
	get mh() {
		return this.morganHillHours
	}
	get la() {
		return this.losAngelesHours
	}
	get chi() {
		return this.chicagoHours
	}
	get nc() {
		return this.northCarolinaHours
	}
	get har() {
		return this.hartfordHours
	}
	get tru() {
		return this.trumbullHours
	}

	get pdxSupply() {
		return this.portlandHeadcount * this.portlandHours
	}
	get mhSupply() {
		return this.morganHillHeadcount * this.morganHillHours
	}
	get laSupply() {
		return this.losAngelesHeadcount * this.losAngelesHours
	}
	get chiSupply() {
		return this.chicagoHeadcount * this.chicagoHours
	}
	get ncSupply() {
		return this.northCarolinaHeadcount * this.northCarolinaHours
	}
	get harSupply() {
		return this.hartfordHeadcount * this.hartfordHours
	}
	get truSupply() {
		return this.trumbullHeadcount * this.trumbullHours
	}
}
